import React, { Fragment } from 'react';
import { shape, string } from 'prop-types';
import {
    compose,
    branch,
    renderComponent,
    setPropTypes,
    setDisplayName,
    withProps,
    withStateHandlers,
} from 'react-recompose';
import { push } from 'react-router-redux';

import ui from '~/state/ducks/ui/actions';
import { isSidebarVisible, getNavbarHeight } from '~/state/ducks/ui/selectors';
import { getUserID, getProductID } from '~/state/ducks/auth/selectors';
import withReduxConnect from '~/views/enhancers/withReduxConnect';

import Page from '../components/Page';
import NobleItems from '../components/NobleItems';
import CollabItems from '../components/CollabItems';

import mapping from '~/utils/mapping.json';


const withLoginPageBranch = branch(
    ({ location: { pathname } }) => pathname === '/login',
    renderComponent(({ children }) => <Fragment>{ children }</Fragment>),
);

const withPageYOffsetState = withStateHandlers({ pageYOffset: 0 }, {
    handleSetPageYOffset: () => () => ({
        pageYOffset: window.pageYOffset,
    }),
});

const withMenuItemsComponent = withProps(({ productID }) => ({
    MenuItems: productID === mapping.license.by_name.NOBLEHOUR
        ? NobleItems
        : CollabItems,
}));

export default compose(
    setDisplayName('PageContainer'),
    setPropTypes({
        location: shape({
            pathname: string.isRequired,
        }).isRequired,
    }),
    withLoginPageBranch,
    withReduxConnect({
        mapStateToProps: state => ({
            isSidebarVisible: isSidebarVisible(state),
            userID: getUserID(state),
            productID: getProductID(state),
            navbarHeight: getNavbarHeight(state),
        }),
        mapDispatchToProps: dispatch => ({
            handleMenuItemClick: (_, { to }) => {
                dispatch(push(to));
                dispatch(ui.sidebar.hide());
            },
            handleHideSidebar: () => dispatch(ui.sidebar.hide()),
        }),
    }),
    withPageYOffsetState,
    withMenuItemsComponent,
)(Page);
